import * as GETTERS from '@/store/constants/getters.js';

const hydrateWorkspace = (workspace, getters) => ({
    ...workspace,
    queues: workspace.queues.map(getters[GETTERS.QUEUE_BY_UUID]).filter((queue) => queue !== undefined),
    saved_searches: workspace.saved_searches.map(getters[GETTERS.SEARCH_BY_UUID]).filter((search) => search !== undefined),
});

export const getters = {
    [GETTERS.WORKSPACE_BY_UUID](state, getters) {
        return (uuid) => {
            const workspace = state.workspaces[uuid];

            if (!workspace) {
                return {};
            }

            return hydrateWorkspace(workspace, getters);
        };
    },

    [GETTERS.CURRENT_WORKSPACE](state, getters) {
        return getters[GETTERS.WORKSPACE_BY_UUID](getters[GETTERS.CURRENT_WORKSPACE_UUID]);
    },

    [GETTERS.ALL_WORKSPACES](state, getters) {
        return () => Object.values(state.workspaces)
            .map((workspace) => hydrateWorkspace(workspace, getters))
            .sort((a, b) => a.name.localeCompare(b.name));
    },

    [GETTERS.IS_WORKSPACE_OWNED_BY_USER](state, getters) {
        return (workspace_uuid) => {
            const currentUserUuid = getters[GETTERS.CURRENT_USER_UUID];

            const workspace = getters[GETTERS.WORKSPACE_BY_UUID](workspace_uuid);

            return currentUserUuid === workspace.owner_uuid;
        };
    },

    [GETTERS.IS_ACTIVE_WORKSPACE_OWNED_BY_USER](state, getters) {
        const currentUserUuid = getters[GETTERS.CURRENT_USER_UUID];
        const currentWorkspaceUuid = getters[GETTERS.CURRENT_WORKSPACE_UUID];

        const workspace = getters[GETTERS.WORKSPACE_BY_UUID](currentWorkspaceUuid);

        return currentUserUuid === workspace.owner_uuid;
    },

    [GETTERS.DOES_WORKSPACE_EXIST](state) {
        return (workspace_uuid) => Boolean(state.workspaces[workspace_uuid]);
    },
};
